export interface IColumnBaseConfig<T> {
  onClick?: (row: T) => void;
  cssClass?: (row: T) => string;
  headerCssClass?: (row: T) => string;
  iconCssClass?: (row: T) => string;
  imgSrcs?: (row: T) => string[];
  textCssClass?: (row: T) => string;
  tooltip?: (row: T) => string;
  imgTooltips?: (row: T) => string[];
  cellTemplate?: (row: T) => string;
  readonly?: (row: T) => boolean;
  includeInGridSettings?: boolean;
  enumFilterMap?: { value: number, name: string }[];
  valueInputTransformRule?: (value: number) => number;
  valueOutputTransformRule?: (value: number) => number;
  isDisplayNameConfigurable?: boolean;
  applyNestedFiltering?: boolean;
  hiddenFromFilter?: boolean;
}

export interface IColumnConfig<T> extends IColumnBaseConfig<T> {
  name: string;
  displayName?: string;
  isSortable?: boolean;
  isExportable?: boolean;
  children?: (row: T) => IChildColumnConfig<T>[];
  headerChildren?: () => IChildColumnConfig<T>[];
  childrenInline?: (row: T) => boolean;
}

export class ColumnConfig<T> implements IColumnConfig<T> {
  name: string;
  displayName: string;
  isSortable?: boolean = true;
  isExportable?: boolean;
  cellTemplate?: (row: T) => string;
  onClick?: (row: T) => void;
  cssClass?: (row: T) => string;
  headerCssClass?: (row: T) => string;
  textCssClass?: (row: T) => string;
  iconCssClass?: (row: T) => string;
  imgSrcs?: (row: T) => string[];
  tooltip?: (row: T) => string;
  imgTooltips?: (row: T) => string[];
  readonly?: (row: T) => boolean;
  children?: (row: T) => IChildColumnConfig<T>[];
  headerChildren?: () => IChildColumnConfig<T>[];
  childrenInline?: (row: T) => boolean;
  includeInGridSettings?: boolean = true;
  enumFilterMap?: { value: number, name: string }[];
  valueInputTransformRule?: (value: number) => number;
  valueOutputTransformRule?: (value: number) => number;
  isDisplayNameConfigurable?: boolean = true;
  applyNestedFiltering?: boolean;
  hiddenFromFilter?: boolean;

  constructor(options: IColumnConfig<T>) {
    Object.assign(this, options);
    if (this.displayName === undefined || this.displayName === null) {
      this.displayName = this.name;
    }
  }
}

export interface IChildColumnConfig<T> extends IColumnBaseConfig<T> { }

export class ChildColumnConfig<T> implements IChildColumnConfig<T> {
  onClick?: (row: T) => void;
  cssClass?: (row: T) => string;
  iconCssClass?: (row: T) => string;
  headerCssClass?: (row: T) => string;
  textCssClass?: (row: T) => string;
  imgSrcs?: (row: T) => string[];
  tooltip?: (row: T) => string;
  imgTooltips?: (row: T) => string[];
  cellTemplate?: (row: T) => string;
  readonly?: (row: T) => boolean;

  constructor(options: IChildColumnConfig<T>) {
    Object.assign(this, options);
  }
}